module.exports = __webpack_public_path__ + "static/media/Avatars_Other-05.3298da27.png";